import { openDB } from "idb";

const DB_NAME = "appDB";
const DB_VERSION = 1;
const STORE_NAME = "screenStorage";

const dbPromise = openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
            db.createObjectStore(STORE_NAME, { keyPath: "id" });
        }
    },
});

// Guardar / actualizar pantalla
export async function saveScreen(screen, data, userCode, role) {
    const db = await dbPromise;

    const id = `${userCode}__${screen}`;
    await db.put(STORE_NAME, { id, screen, data, userCode, role, savedAt: Date.now() });
}

// Obtener pantalla
export async function getScreen(screen, userCode, role) {
    const db = await dbPromise;
    const id = `${userCode}__${screen}`;
    const result = await db.get(STORE_NAME, id);

    if (!result) return null;

    const isNotSameUser = (result.userCode !== userCode) || (result.role !== role);
    if (isNotSameUser) {
        return null;
    }

    const savedDate = new Date(result.savedAt);
    const now = new Date();

    const isExpired =
        savedDate.getFullYear() !== now.getFullYear() ||
        savedDate.getMonth() !== now.getMonth() ||
        savedDate.getDate() !== now.getDate();

    if (isExpired) {
        await db.delete(STORE_NAME, id);
        return null;
    }

    return result;
}

// Obtener solo el objeto data
export async function getScreenData(screen, userCode, role) {
    const result = await getScreen(screen, userCode, role);
    return result?.data ?? null;
}

// Borrar pantalla
export async function deleteScreen(screen) {
    const db = await dbPromise;
    await db.delete(STORE_NAME, screen);
}

// Limpiar todas las pantallas
export async function clearAllScreens() {
    const db = await dbPromise;
    await db.clear(STORE_NAME);
}

// Obtener todas las pantallas
export async function getAllScreens() {
    const db = await dbPromise;
    return db.getAll(STORE_NAME);
}

// Ver si existe pantalla
export async function hasScreen(screen, userCode, role) {
    const result = await getScreen(screen, userCode, role);
    return !!result;
}
